
 
const localIP = process.env.REACT_APP_API_URL;
console.log(process.env.REACT_APP_API_URL);

const backendIP = localIP;   

export default backendIP;